define('view/controller/booking/datetime/grid-weekly/TimeGridWeeklyDayView',['require','marionette','lib/Utils','view/controller/booking/datetime/grid-weekly/TimeGridWeeklyDayItemView','collection/TimeGridCollection','lib/view/UnwrapBehavior'],function (require) {

    var Parent = require('marionette').CompositeView;
    var Utils = require('lib/Utils');
    var TimeGridWeeklyDayItemView = require('view/controller/booking/datetime/grid-weekly/TimeGridWeeklyDayItemView');
    var TimeGridCollection = require('collection/TimeGridCollection');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    return Parent.extend({

        template: '#time_grid_weekly_day_view',
        childView: TimeGridWeeklyDayItemView,
        childViewContainer: '.sb_time_grid_weekly_day_container',

        childViewOptions: function (model, index) {
            return {
                clientTimeZone: this.getOption('clientTimeZone'),
                serviceModel: this._serviceCollection.get(model.get('service_id')),
                providerModel: this._providerCollection.get(model.get('provider_id'))
            };
        },
        
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        initialize: function () {
            Parent.prototype.initialize.apply(this);
            
            this.collection = this.model.get('collection');
            this._activeTimeOfDay = this.getOption('activeTimeOfDay');
            this._serviceCollection = this.getOption('serviceCollection');
            this._providerCollection = this.getOption('providerCollection');
            this._waitingListHelperModel = this.getOption('waitingListHelperModel');
        },

        serializeData: function () {
            var result = Parent.prototype.serializeData.apply(this);
            result.time_diff = Utils.timeDiff(result, this.getOption('clientTimeZone'));

            var date = Date.parseMysqlDate(result.date);

            result.day_name = date.getWeekDayName('medium');
            result.is_holiday = ([0, 6].indexOf(date.getDay()) !== -1);
            
            result.isEmpty = !this.collection.any(this.filter.bind(this));

            //var notAvServices = this._getNotAvailableServices();

           // console.log(notAvServices);

            // if(this._waitingListHelperModel && result.isEmpty) {
            //     var isAvailableInterval = this._waitingListHelperModel.isTodayOrFutureDates(result.date) && !_.every(_.values(this._waitingListHelperModel.isWorkDay(result.date)), function (val) {
            //         return val;
            //     });
            //     result.isEmpty = !isAvailableInterval;
            //
            //     if(!isAvailableInterval){
            //         this.emptyView = null;
            //     }
            //
            // }

            return result;
        },
        
        filter: function (child, index, collection) {
            return this._filterByTime(child);
        },
        
        _filterByTime: function (model) {
            var timeDiff = this.getOption('clientTimeZone').get('time_diff');
            var activeTimeOfDay = this._activeTimeOfDay;
            
            return TimeGridCollection.matchesTime(model, timeDiff, activeTimeOfDay);
        },

    });

});
